<template>
  <div class="fds-rich-text-editor__menubar__group">
    <slot />
  </div>
</template>